// extracted by mini-css-extract-plugin
module.exports = {"errorPageContainer":"ErrorPage_errorPageContainer__gz_Js"};